import { render, staticRenderFns } from "./BindResult.vue?vue&type=template&id=a2ea7a16&scoped=true"
import script from "./BindResult.vue?vue&type=script&lang=js"
export * from "./BindResult.vue?vue&type=script&lang=js"
import style0 from "./BindResult.vue?vue&type=style&index=0&id=a2ea7a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ea7a16",
  null
  
)

export default component.exports